import script from "./SubscriptionComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionComplete.vue?vue&type=script&setup=true&lang=js"

export default script